import SmartTipsHA from './SmartTipsHA';

export default SmartTipsHA;
